<template>
    <ExtendedLayout
        :user="user"
        currentTab="documents"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2 mb-4">
                <InertiaLink :href="$route('admin::users.documents.index', { user: user.id })">
                    <ChevronLeftIcon class="w-4 h-4 text-gray-500" />
                </InertiaLink>
                {{ __('admin::general.create_model', {'model': __('admin::documents.document').toLowerCase() }) }}
            </Heading>

            <form @submit.prevent="submit">

                <FormGroup :label="__('admin::labels.type')" :error="errors.type">
                    <Select name="type" :options="documentTypeOptions" :has-error="exists(errors.type)" v-model="form.type" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.name')" :error="errors.name" optional>
                    <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.file')" :error="errors.file">
                    <FileInput name="name" :has-error="exists(errors.file)" v-model="form.file" :required="true" />
                </FormGroup>

                <Button :loading="form.processing">
                    {{ __('admin::general.create_model', {'model': __('admin::documents.document').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';
import {ChevronLeftIcon} from "@heroicons/vue/outline";

export default {
    components: {
        ChevronLeftIcon,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        user: Object,
        documentTypeOptions: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                type: Object.keys(this.documentTypeOptions)[0],
                name: null,
                file: null,
            })
        }
    },
    methods: {
        submit() {
            this.form
                .post(this.$route('admin::users.documents.store', { user: this.user.id }));
        },
    }
}
</script>
